import React, { FC } from 'react';

import { Box } from '@mui/system';
import { Typography } from '@mui/material';

import { currency, pharmacyBillingSelector } from '@pharmaplan/common';

import SavedCard from '../../../Profile/PharmacyFlow/PharmacyBilling/ExistingPaymentPlan/SavedPlanDetails/SavedCard';
import useUpdateCardDetails from '../../../../hooks/Payment/useUpdateCardDetails';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import CustomButton from '../../../common/CustomButton';
import strings from '../../../../localization';

import styles from './styles';

interface IBillableCard {
  requestedShifts?: number;
}

const BillableCard: FC<IBillableCard> = ({ requestedShifts }) => {
  const billing = useAppSelector(pharmacyBillingSelector);
  const { basicFees } = billing ?? {};

  const { updatePaymentMethod } = useUpdateCardDetails();
  const price = requestedShifts
    ? `(${currency}${basicFees} x ${requestedShifts})`
    : `${currency}${basicFees}`;

  return (
    <Box sx={styles.container}>
      <Box>
        <SavedCard showCardType={false} customTitle={strings.pharmaPlanFees} />
      </Box>
      <Box>
        <Box sx={styles.price}>
          <Typography sx={styles.priceLabel}>
            {`${price} + ${strings.tax}`}
          </Typography>
        </Box>
        <CustomButton
          label={strings.update}
          onClick={updatePaymentMethod}
          customButtonStyle={styles.updateButton}
          variant="text"
        />
      </Box>
    </Box>
  );
};

export default BillableCard;
